import { lazy } from 'react';

import { Loadable } from '../components/Loadable';
import { PublicLayout } from '../Layout/public';

const FinancialAssistanceForm = Loadable(
   lazy(() => import('../pages/financialAssistance'))
);
const FinancialAssistanceStatus = Loadable(
   lazy(() => import('../pages/financialAssistance/FinancialAssistanceStatus'))
);

const publicRoutes = {
   path: '/',
   children: [
      {
         path: '/public',
         element: <PublicLayout />,
         children: [
            {
               path: 'auxilios_financieros',
               element: <FinancialAssistanceForm />,
            },
         ],
      },
      {
         path: 'auxilios_financieros_estado/:status',
         element: <FinancialAssistanceStatus />,
      },
   ],
};

export default publicRoutes;
